/**
 * Cliente REST del catálogo INTERNO de la academia (plan 06 · E1, cierra D2).
 *
 * Sustituye al stream `org_courses` de PowerSync, que colgaba de `member` sin
 * filtrar rol ni estado de publicación: cualquier miembro —incluido un alumno—
 * replicaba offline el árbol de TODOS los cursos de la academia, con borradores
 * y cursos borrados dentro. El servidor decide ahora qué se ve
 * (`ManageAcademics` para los borradores) y el alumno conserva offline el curso
 * en el que está matriculado (streams `my_enrolled_courses`/`my_cohort_courses`).
 *
 * El TIPO no se escribe a mano: viene del OpenAPI generado desde Rust
 * (`pnpm gen:api-types`) — política de datos §4.2, «el tipo se comparte, no se
 * copia». Mismo patrón de auth cookie-BFF que metrics/CRM/billing.
 */
import type { components } from "@space/client";
import { apiJson } from "@/lib/rest";

/** Ficha del catálogo interno (== `core_rust::db::academy_catalog::OrgCourseEntry`). */
export type OrgCourseEntry = components["schemas"]["OrgCourseEntryDTO"];

const BASE = "/api/academy";

function orgUrl(orgId: string): string {
  return `${BASE}/${encodeURIComponent(orgId)}/courses`;
}

/**
 * Fichas del catálogo interno de la academia (sin árbol).
 *
 * Los otros tres endpoints del recurso —árbol
 * (`GET …/courses/:courseId`), publicar (`POST …/courses`) y despublicar
 * (`DELETE …/courses/:courseId`)— viven en el servidor con su tipo ya generado
 * en `@space/client`; no se envuelven aquí hasta que tengan consumidor: un
 * wrapper sin uso es código muerto que el guard de exports no perdona.
 */
export function fetchOrgCourses(orgId: string): Promise<OrgCourseEntry[]> {
  return apiJson<OrgCourseEntry[]>(orgUrl(orgId));
}
